import data from "./data";
const initState = {
  data
};

const chartReducer = (state = initState) => {
  return state;
};

export default chartReducer;
